import { Box, Fab, List, ListItem, Typography } from "@mui/material";

import React, { useMemo, useState } from "react";
import { Proposition } from "../../utils/types";
import { ContentWrapper } from "../../components/ContentWrapper";
import { findPropositions } from "../../database/queries/queries";
import { PropositionCard } from "../../components/PropositionCard/PropositionCard";
import { Loading } from "../../components/Loading";
import { Button, Menu, MenuItem } from "@mui/material";
import { CompassCalibration, ExpandMoreOutlined } from "@mui/icons-material";
import { useInfiniteQuery } from "@tanstack/react-query";
import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore";

export const PropositionsList = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setFilterAnchorEl(null);
  };

  const [sort, setSort] = useState<string>("timestamp");
  const [filterAnchorEl, setFilterAnchorEl] = useState<null | HTMLElement>(
    null
  );

  const filterOpen = Boolean(filterAnchorEl);

  const handleFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const [filter, setFilter] = useState<string | null>("SENT");

  // useEffect(() => {
  //   getPropositions(locations, themes, sort, filter);
  // }, [locations, themes, sort, filter]);

  const { data, fetchNextPage, isLoading, error } = useInfiniteQuery({
    queryKey: ["propositions", filter],
    queryFn: ({ pageParam }) => {
      return findPropositions(pageParam, filter);
    },
    initialPageParam: null as null | QueryDocumentSnapshot<Proposition>,
    getNextPageParam: (lastPage) => {
      return lastPage.updatedLastVisible;
    },
  });

  if (error) {
    console.error("[PropositionsList] Query error:", error);
  }

  const getSortedPropositions = (propositions: Proposition[]) => {
    const sortedPropositions = [...propositions];
    switch (sort) {
      case "timestamp":
        return sortedPropositions.sort(
          (a, b) => a.createdAt.seconds - b.createdAt.seconds
        );
      case "title":
        return sortedPropositions.sort((a, b) =>
          a.title.localeCompare(b.title)
        );
      default:
        return sortedPropositions.sort((b, a) =>
          a.status.localeCompare(b.status)
        );
    }
  };

  const propositions = useMemo(() => {
    if (!data?.pages) return [];
    const list = data.pages.map((page) => page.propositions).flat();
    return getSortedPropositions(list);
  }, [data?.pages, sort, filter]);

  const handleFilter = (status: string) => {
    setFilter(status);
    handleClose();
  };

  return (
    <>
      <h3> Lista de propostas </h3>
      <Box sx={{ pb: 8 }}>
        <div>
          <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            Ordenar
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={() => setSort("timestamp")}>
              Ordenar por data
            </MenuItem>
            <MenuItem onClick={() => setSort("title")}>
              Ordenar por Título
            </MenuItem>
            <MenuItem onClick={() => setSort("status")}>
              Ordenar por Status
            </MenuItem>
          </Menu>

          <Button
            id="filter-button"
            aria-controls={filterOpen ? "filter-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={filterOpen ? "true" : undefined}
            onClick={handleFilterClick}
          >
            Mostrar propostas
          </Button>
          <Menu
            id="filter-menu"
            anchorEl={filterAnchorEl}
            open={filterOpen}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "filter-button",
            }}
          >
            <MenuItem onClick={() => handleFilter("SENT")}>
              Propostas Pendente
            </MenuItem>
            <MenuItem onClick={() => handleFilter("DENIED")}>
              Propostas negada
            </MenuItem>
            <MenuItem onClick={() => handleFilter("APPROVED")}>
              Propostas aprovada
            </MenuItem>
          </Menu>
        </div>
        <ContentWrapper hasScroll>
          {isLoading ? (
            <Loading />
          ) : (
            <List
              sx={{
                alignItems: "center",
                justifyContent: "flex-start",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {propositions && propositions.length > 0 ? (
                <>
                  {propositions.map((item) => (
                    <ListItem
                      key={item.id}
                      sx={{ paddingTop: 0, paddingBottom: 0, maxWidth: "sm" }}
                    >
                      <PropositionCard {...item} />
                    </ListItem>
                  ))}
                  <Fab
                    sx={{ position: "fixed", bottom: 0, right: "96px" }}
                    onClick={() => {
                      fetchNextPage();
                      document
                        .querySelector("#content-wrapper")
                        ?.scrollTo(0, 0);
                    }}
                  >
                    <ExpandMoreOutlined />
                  </Fab>
                </>
              ) : (
                <Box textAlign="center" mt={4}>
                  <CompassCalibration sx={{ fontSize: 64 }} color="disabled" />
                  <Typography variant="h5" color="textSecondary">
                    Sem propostas novas
                  </Typography>
                </Box>
              )}
            </List>
          )}
        </ContentWrapper>
      </Box>
    </>
  );
};
